import React, { lazy, Suspense } from 'react';

const LazyOrderHistoryXSeriesCarts = lazy(() => import('./OrderHistoryCarts'));

const OrderHistoryXSeriesCarts = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrderHistoryXSeriesCarts {...props} />
  </Suspense>
);

export default OrderHistoryXSeriesCarts;
